import React from 'react';
import projectUtils from "../../../../../../../utils/project-utils.js";
import CheckHasData from "../../check-has-data.jsx";

const DivisorItem = ({icon, text, value}) => {
    return (
        <div className={"flex items-top mb-2"}>
            <div className={"w-[30px]"}>
                {icon}
            </div>
            <p className={"mb-0 w-[calc(100%-30px)]"}>
                {text}: <b className={"ml-1"}><CheckHasData value={value} /></b>
            </p>
        </div>
    );
};

export default DivisorItem;